/**
 * PBI 1962 (AB#1968) — Service option-groups builder feature flag.
 *
 * Controls whether the Salon-Owner service builder shows the new flexible
 * option-group editor (variants + add-ons with selection rules) that produces
 * the backend's `OptionGroupsJson` contract, alongside the legacy flat
 * `PricingOptionsJson`.
 *
 * Default is **OFF** — the builder ships DARK. While OFF the owner sees the
 * classic flat pricing-options list exactly as before and only
 * `PricingOptionsJson` is sent; the new `OptionGroupsJson` field is never
 * populated. This mirrors the backend `service_option_groups` kill-switch,
 * which stays OFF until the whole feature is enabled end-to-end (Phase 1+2
 * backend is merged + baked; Phase 3 web + Phase 4 mobile land dark).
 *
 * Authoring data written while dark is harmless: the backend auto-wraps the
 * flat options into an implicit Variant group regardless, so nothing depends
 * on the web client sending `OptionGroupsJson` until the flag is flipped.
 *
 * Flip to `true` in `.env.local` / `.env.development` for dogfood, then via the
 * Azure Static Web Apps env var for staged prod rollout — only AFTER the
 * backend `service_option_groups` flag is turned on.
 *
 * Environment variable: `REACT_APP_SERVICE_OPTION_GROUPS_ENABLED`
 * (string "true", case-insensitive, to enable).
 */
export const isServiceOptionGroupsEnabled = (): boolean =>
    (process.env.REACT_APP_SERVICE_OPTION_GROUPS_ENABLED ?? '').toLowerCase() === 'true';
